import { IAuthClient } from '@tdp/common/auth';
import { IThemeReader } from '@tdp/common/theme/abstractions';

export enum HostType {
  TEAMS = "teams",
  WEB = "web",
  E2E = "e2e"
}


/**
 * Interface for all the services TDP requires from its host beyond the
 * standard WHATWG APIs.
 *
 * This is a utility type for helping collate all the services so adding a new host is just
 * implementing this interface.
 */
export interface ITdpClientHost {
  auth: IAuthClient;
  themeReader: IThemeReader;
  // TODO(nibeauli): deeplink service?
  // TODO(nibeauli): user service?
  // TODO(nibeauli): host info service?
}
